import { getApiBaseUrl } from './config';
import { portalFetch } from '../auth/portalSession';

export interface Service {
  service_id: string;
  service_name: string;
  supported_days?: string[];
  is_active: boolean;
  supported_providers?: string[];
  created_at?: string;
  updated_at?: string;
}

export const getServicesApi = async (): Promise<Service[]> => {
  const response = await portalFetch('secretary', `${getApiBaseUrl()}/services`);
  if (!response.ok) {
    throw new Error('Failed to fetch services');
  }
  const data = await response.json();
  // Backend returns { services: [...], count: number }
  return data.services || [];
};
